import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { cpLogin } from "@/lib/api";
import { TID } from "@/constants/testIds";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await cpLogin(password);
      localStorage.setItem("phc-admin-token", res.token);
      nav("/admin/portal");
    } catch {
      toast.error("Invalid password. Contact the site owner.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-void grid place-items-center px-5 py-16 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80&auto=format&fit=crop')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-void/70" />
      <div className="relative w-full max-w-md bg-offwhite rounded-2xl p-8 md:p-10 fade-up">
        <Link to="/" className="eyebrow text-teal">← Back to the site</Link>
        <div className="mt-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-forest text-cream grid place-items-center">
            <Lock size={16} />
          </div>
          <h1 className="font-display text-forest text-3xl md:text-4xl leading-tight">
            Admin Console
          </h1>
        </div>
        <p className="mt-3 text-forest/70 text-sm">
          Restricted access. Sitewide lead capture, event registrations,
          chatbot conversations, and integration settings.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="eyebrow text-forest/60 block mb-1">Access Password</span>
            <input
              data-testid={TID.cpPassword}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-0 border-b border-forest/25 bg-transparent py-3 focus:outline-none focus:border-forest text-forest"
            />
          </label>
          <button data-testid={TID.cpLoginSubmit} disabled={loading} className="btn-primary w-full">
            {loading ? "Verifying…" : "Enter Admin Console"}
          </button>
        </form>
        <div className="mt-6 text-xs text-forest/50">
          Unauthorised access is prohibited.
        </div>
      </div>
    </div>
  );
}
